import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MemberOfficeShort } from '@app/models/memberofficeshort';
@Injectable({
  providedIn: 'root'
})
export class MemberofficeService {

  constructor(private http: HttpClient) { }

  GetMemberOfficesByMemberIdAsync(roleid: number, id: number) {
    return this.http.get<any>(environment.apiUrl + 'Office/GetMemberOfficesByMemberIdAsync/' + Number(roleid) + '/' + id);
  }

  SearchMemberFromInstitutionByNameOrId(memberoffice: MemberOfficeShort) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMemberFromInstitutionByNameOrId', JSON.stringify(memberoffice), httpOptions);
  }

  GetPossibleSigns(institutionId: number) {
    return this.http.get<any>(environment.apiUrl + 'Sign/GetPossibleSigns/' + institutionId);
  }

  GetPossibleOffices(institutionId: number) {
    return this.http.get<any>(environment.apiUrl + 'Office/GetPossibleOffices/' + institutionId);
  }

  UpdateMemberSign(membersigndata) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Sign/UpdateMemberSign', JSON.stringify(membersigndata), httpOptions);
  }

  UpdateMemberOffice(memberoffice) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Office/UpdateMemberOffice', JSON.stringify(memberoffice), httpOptions);
  }

  GetMemberOfficeListing(institutions: Number[]) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Office/GetMemberOfficeListing', JSON.stringify(institutions), httpOptions);
  }

  GetMemberMainListing(roleid: number, members: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
   
  return this.http.post<any>(environment.apiUrl + 'Office/GetMemberMainListing?userRoleId=' + roleid, JSON.stringify(members), httpOptions);
    //return this.http.post<any>(environment.apiUrl + 'Office/GetMemberMainListing', JSON.stringify(members), httpOptions);
  }

  GetOffices() {
    return this.http.get<any>(environment.apiUrl + 'Office/GetOffices');
  }

  GetOfficesByOfficeType(id: string) {
    let params = new HttpParams();
    params = params.append('OfficeTypeId', id);
    return this.http.get<any>(environment.apiUrl + 'Office/GetOffices', { params: params });
  }

  GetOfficesTypes() {
    return this.http.get<any>(environment.apiUrl + 'Office/GetOfficesTypes');
  }

  Committees() {
    return this.http.get<any>(environment.apiUrl + 'Office/Committees');
  }

  getCommitteesByOfficeId(id: string) {
    let params = new HttpParams();
    params = params.append('OfficeId', id);
    return this.http.get<any>(environment.apiUrl + 'Office/Committees', { params: params });
  }
}
